module.exports = __webpack_public_path__ + "img/macguffin.1b60bb77.svg";